var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.99998C9.05448 6.99998 6.66667 9.38779 6.66667 12.3333C6.66667 15.2788 9.05448 17.6666 12 17.6666C14.9455 17.6666 17.3333 15.2788 17.3333 12.3333C17.3333 9.38779 14.9455 6.99998 12 6.99998ZM9.33333 12.3333C9.33333 10.8606 10.5272 9.66665 12 9.66665C13.4728 9.66665 14.6667 10.8606 14.6667 12.3333C14.6667 13.8061 13.4728 15 12 15C10.5272 15 9.33333 13.8061 9.33333 12.3333Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.333313C8.8174 0.333313 5.76516 1.5976 3.51472 3.84803C1.26428 6.09847 0 9.15071 0 12.3333C0 14.7192 1.06451 17.2865 2.91712 19.9875C4.78163 22.7058 7.53077 25.6846 11.105 28.9216C11.609 29.3781 12.3758 29.3821 12.8847 28.9309C16.4664 25.7546 19.2187 22.7728 21.0851 20.0342C22.9387 17.3145 24 14.7155 24 12.3333C24 9.15071 22.7357 6.09847 20.4853 3.84803C18.2348 1.5976 15.1826 0.333313 12 0.333313ZM5.40034 5.73365C7.15068 3.98331 9.52465 2.99998 12 2.99998C14.4754 2.99998 16.8493 3.98331 18.5997 5.73365C20.35 7.48399 21.3333 9.85796 21.3333 12.3333C21.3333 13.9511 20.5947 16.0188 18.8815 18.5324C17.3299 20.8091 15.0448 23.3551 12.0086 26.1315C8.96186 23.2962 6.67105 20.746 5.11621 18.4791C3.40216 15.9801 2.66667 13.9474 2.66667 12.3333C2.66667 9.85796 3.65 7.48399 5.40034 5.73365Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.482d1ede13f712efbfbb516839caa226.svg";
export { ForwardRef as ReactComponent };